import axios, { AxiosInstance } from 'axios';
import { Auth } from 'aws-amplify';
import { CognitoUserSession } from 'amazon-cognito-identity-js';

class ApiService {
    private auth: typeof Auth;
    private httpClient: AxiosInstance;
    private apiGatewayUrlParam: string;

    constructor(apiGatewayUrlParam: string, auth: typeof Auth = Auth, httpClient: AxiosInstance = axios) {
        this.apiGatewayUrlParam = apiGatewayUrlParam;
        this.auth = auth;
        this.httpClient = httpClient;
    }

    private async getAuthHeaders(): Promise<{ headers: { Authorization?: string } }> {
        let currentSession: CognitoUserSession | null;
        try {
            currentSession = await this.auth.currentSession();
        } catch (err) {
            currentSession = null;
        }

        if (currentSession?.getIdToken()?.getJwtToken()) {
            const jwtToken = currentSession.getIdToken().getJwtToken();
            return { headers: { 'Authorization': jwtToken } };
        } else {
            return { headers: {} };
        }
    }

    async getRequest(apiURL: string, params: any = {}): Promise<any> {
        if (!this.apiGatewayUrlParam) {
            throw new Error("apiGatewayUrlParam has not been set");
        }

        const apiRes = await this.httpClient.get(this.apiGatewayUrlParam + apiURL, { ...await this.getAuthHeaders(), params });
        return apiRes.data;
    }

    async postRequest(apiURL: string, data: any = {}): Promise<any> {
        if (!this.apiGatewayUrlParam) {
            throw new Error("apiGatewayUrlParam has not been set");
        }

        const apiRes = await this.httpClient.post(this.apiGatewayUrlParam + apiURL, data, await this.getAuthHeaders());
        return apiRes.data;
    }

    async putRequest(apiURL: string, data: any = {}): Promise<any> {
        if (!this.apiGatewayUrlParam) {
            throw new Error("apiGatewayUrlParam has not been set");
        }

        const apiRes = await this.httpClient.put(this.apiGatewayUrlParam + apiURL, data, await this.getAuthHeaders());
        return apiRes.data;
    }
}

export default ApiService;
